<template>
  <div>
    <div class="animates-items mb16 verticallyCenter">
      <div class="verticallyCenter mr12">
        <span class="fs14 mr8">宽</span>
        <el-input class="input-size" type="number" placeholder="-" v-model="width" @focus="getFocus($event)">
          <template slot="suffix">
            <el-dropdown trigger="click" @command="widthTypeHandleCommand">
              <span class="el-dropdown-link lineHeight32">
                {{ widthType }}
              </span>
              <el-dropdown-menu slot="dropdown" class="dropdown-size">
                <el-dropdown-item
                  v-for="(sizeType, index) in sizeTypes"
                  :command="sizeType.value"
                  :key="'sizeType_' + index"
                  ><span class="selected-icon" :class="widthType === sizeType.value ? 'icon-portal-check-small' : ''"></span
                  >{{ sizeType.label }}</el-dropdown-item
                >
              </el-dropdown-menu>
            </el-dropdown>
          </template>
        </el-input>
      </div>
      <div class="verticallyCenter">
        <span class="fs14 mr8">高</span>
        <el-input class="input-size" type="number" placeholder="-" v-model="height" @focus="getFocus($event)">
          <template slot="suffix">
            <el-dropdown trigger="click" @command="heightTypeHandleCommand">
              <span class="el-dropdown-link lineHeight32">
                {{ heightType }}
              </span>
              <el-dropdown-menu slot="dropdown" class="dropdown-size">
                <el-dropdown-item
                  v-for="(sizeType, index) in sizeTypes"
                  :command="sizeType.value"
                  :key="'sizeType_' + index"
                  ><span class="selected-icon" :class="heightType === sizeType.value ? 'icon-portal-check-small' : ''"></span
                  >{{ sizeType.label }}</el-dropdown-item
                >
              </el-dropdown-menu>
            </el-dropdown>
          </template>
        </el-input>
      </div>
    </div>
    <div class="animates-items">
      <slider-and-input
        class="mb16"
        inputWidth="small"
        inputHeight="small"
        :value.sync="animateDataVal.animateDuration"
        title="持续"
        titlePosition="allInOneLine"
        :sliderMax="10000"
        suffix="ms"
      />
      <slider-and-input
        class="mb16"
        inputWidth="small"
        inputHeight="small"
        :value.sync="animateDataVal.animateDelay"
        title="延迟"
        titlePosition="allInOneLine"
        :sliderMax="10000"
        suffix="ms"
      />
      <div class="verticallyCenter">
        <div class="mr16">触发</div>
        <div class="content">
          <el-radio-group v-model="animateDataVal.animationIterationCount">
            <el-radio
              v-for="(option, index) in triggerstyles.list"
              :key="index"
              :label="option.value"
              :disabled="option.disabled"
              >{{ option.title }}</el-radio
            >
          </el-radio-group>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "borderRadius-setting",
  components: {},
  props: {
    animateData: {
      type: Object
    },
    options: {
      type: Object
    }
  },
  data() {
    return {
      triggerstyles: {
        type: "触发次数",
        checked: "单次触发",
        list: [
          {
            value: 1,
            disabled: false,
            title: "单次触发"
          },
          {
            value: 2,
            disabled: false,
            title: "多次触发"
          }
        ]
      },
      sizeTypes: [
        {
          label: "px",
          value: "px"
        },
        {
          label: "%",
          value: "%"
        }
      ],
      heightType: "px",
      widthType: "px"
    }
  },
  computed: {
    ids() {
      return this.$store.state.states.activeID
    },
    animateDataVal: {
      get() {
        return this.animateData
      },
      set(newVal) {
        this.$emit("update:animateData", newVal)
      }
    },
    width: {
      get() {
        let triggerType = this.animateDataVal.triggerType
        let colorName = `${triggerType}Width`
        this.widthType = this.animateDataVal.variable[colorName].indexOf("%") > -1 ? "%" : "px"
        return parseInt(this.animateDataVal.variable[colorName])
      },
      set(newVal) {
        let triggerType = this.animateDataVal.triggerType
        let colorName = `${triggerType}Width`
        let newWidth = newVal / 2 + this.widthType
        let marginLeft = `calc(50% - ${newWidth})`
        if (this.options.leftType === "%") {
          this.animateDataVal.variable[`${triggerType}MarginLeft`] = marginLeft
        }
        this.animateDataVal.variable[colorName] = newVal + this.widthType
      }
    },
    height: {
      get() {
        let triggerType = this.animateDataVal.triggerType
        let colorName = `${triggerType}Height`
        this.heightType = this.animateDataVal.variable[colorName].indexOf("%") > -1 ? "%" : "px"
        return parseInt(this.animateDataVal.variable[colorName])
      },
      set(newVal) {
        let triggerType = this.animateDataVal.triggerType
        let colorName = `${triggerType}Height`
        let newHeight = newVal / 2 + this.heightType
        let marginTop = `calc(50% - ${newHeight})`
        if (this.options.topType?.indexOf("%") > -1) {
          this.animateDataVal.variable[`${triggerType}MarginTop`] = marginTop
        }
        this.animateDataVal.variable[colorName] = newVal + this.heightType
      }
    }
  },
  mounted() {},
  methods: {
    widthTypeHandleCommand(val) {
      if (this.widthType === val) {
        return
      }
      this.widthType = val
      this.width = val === "%" ? 100 : 200
    },
    heightTypeHandleCommand(val) {
      if (this.heightType === val) {
        return
      }
      this.heightType = val
      this.height = val === "%" ? 100 : 200
    },
    getFocus(event) {
      event.currentTarget.select()
    }
  }
}
</script>

<style lang="scss" scoped>
.lineHeight32 {
  display: inline-block;
  line-height: 32px;
}
.color000 {
  color: var(--text);
}
::v-deep .el-dropdown-link {
  color: var(--subTextColor) !important;
}
::v-deep .input-size .el-input__suffix {
  right: 4px;
}
::v-deep .input-size .el-dropdown-link {
  width: 24px;
  height: 24px;
  line-height: 24px;
  border-radius: 3px;
  margin: 4px 0;
}
::v-deep .input-size .el-dropdown-link:hover {
  background: var(--paddingIconHoverColor);
}
.selected-icon {
  position: absolute;
  top: 50%;
  left: 12px;
  font-size: 16px;
  color: var(--themeColor);
  transform: translateY(-50%);
}
.dropdown-size {
  margin-top: -32px;
}

.dropdown-size li {
  position: relative;
  width: 90px;
  padding-left: 36px;
}
.el-dropdown-menu__item {
  color: var(--textColor);
}
</style>
